import React, { useState, useEffect, useRef } from "react";
import { Contactform } from './Contactform'
export default function AutoPopup() {
  const [open, setOpen] = useState(false);
  const timerRef = useRef(null);

  useEffect(() => {
    timerRef.current = setTimeout(() => {
      setOpen(true);
    }, 14000);

    return () => clearTimeout(timerRef.current);
  }, []);

  const closePopup = () => {
    setOpen(false);

    clearTimeout(timerRef.current);

    timerRef.current = setTimeout(() => {
      setOpen(true);
    }, 16000);
  };

  return (
    <>
      {open && (
        <div className="popup-overlay">
          <div className="popup-box">

            {/* Close Icon */}
            <span
              className="popup-close"
              onClick={closePopup}
            >
              ×
            </span>

            {/* Popup Content */}
            <div className="popup-content">
          <Contactform />

              <button
                className="popup-btn"
                onClick={closePopup}
              >
                Close
              </button>
            </div>

          </div>
        </div>
      )}
    </>
  );
}